// extracted by mini-css-extract-plugin
module.exports = {"container":"page_container__nCJSc","page_title":"page_page_title__2L-h6"};